import { apiServices } from "../../../core/utilities/ApiServices";

export interface CommunityHelpPost {
  id: string;
  kind: string;
  title: string;
  body: string;
  adminStatus: string;
  affectedCount: number;
  displayName?: string;
}

const toText = (value: unknown) => (typeof value === "string" ? value : "");

const toCount = (value: unknown) => {
  if (typeof value === "number") return Math.round(value);
  const parsed = Number(value);
  return Number.isFinite(parsed) ? Math.round(parsed) : 0;
};

const mapPost = (json: any): CommunityHelpPost => ({
  id: toText(json?.id),
  kind: toText(json?.kind),
  title: toText(json?.title),
  body: toText(json?.body),
  adminStatus: toText(json?.admin_status) || "New",
  affectedCount: toCount(json?.affected_count),
  displayName: toText(json?.display_name).trim() || undefined,
});

export const getCommunityPosts = async () => {
  const response = await apiServices.get("/community/posts");
  return Array.isArray(response.data) ? response.data.map(mapPost) : [];
};

export const submitCommunityPost = async ({
  kind,
  title,
  body,
  displayName,
}: {
  kind: string;
  title: string;
  body: string;
  displayName?: string;
}) => {
  await apiServices.post("/community/posts", {
    kind,
    title,
    body,
    display_name: displayName,
    device_type: "Web",
    app_version_build: "web",
  });
};

export const supportCommunityPost = async (postId: string) => {
  const response = await apiServices.post(`/community/posts/${postId}/me-too`);
  return mapPost(response.data);
};

export const submitLoginIssue = async ({
  email,
  loginMethod,
  whatHappened,
}: {
  email: string;
  loginMethod: string;
  whatHappened: string;
}) => {
  await apiServices.post("/community/login-issues", {
    email,
    login_method: loginMethod,
    what_happened: whatHappened,
    device_type: "Web",
    app_version_build: "web",
  });
};
